"use client";

import { SITE_TIMEZONE } from "@/lib/site";
import { useEffect, useState } from "react";

interface Props {
  /** Intl.DateTimeFormatOptions to control display format */
  options?: Intl.DateTimeFormatOptions;
  className?: string;
  /** Optional prefix string rendered before the date (e.g. " на ") — hidden when date not yet loaded */
  prefix?: string;
  /** Optional suffix string rendered after the date (e.g. ".") — hidden when date not yet loaded */
  suffix?: string;
}

const DEFAULT_OPTIONS: Intl.DateTimeFormatOptions = {
  weekday: "long",
  day: "numeric",
  month: "long",
  year: "numeric",
};

/**
 * Renders today's date on the client side, avoiding ISR-cached stale dates.
 * Falls back to an empty string during SSR / hydration to prevent mismatch.
 */
export function TodayDate({ options = DEFAULT_OPTIONS, className, prefix, suffix }: Props) {
  const [dateStr, setDateStr] = useState("");

  useEffect(() => {
    // RULE-TZ-XX: дата строго по Москве (caller может переопределить timeZone).
    setDateStr(new Date().toLocaleDateString("es-ES", { timeZone: SITE_TIMEZONE, ...options }));
  }, [options]);

  if (!dateStr) return null;

  return <span className={className}>{prefix}{dateStr}{suffix}</span>;
}
